import bs58 from 'bs58';
import nacl from 'tweetnacl';
import { SignInWithMessage } from './SignInWithMessage';
export class SiwsMessage extends SignInWithMessage {
    isMessageSigned(message, signature, address) {
        const isValid = nacl.sign.detached.verify(new TextEncoder().encode(message), bs58.decode(signature), bs58.decode(address));
        return isValid;
    }
}
